@let savedEstimate = data();
<section class="detail-grid">
    <div class="col col-1">
        @for (keyValuePair of keyValuePairs(); track $index) {
            <div class="keyvalue-pair">
                <div class="key">{{ keyValuePair.key }}</div>
                <div [class]="keyValuePair.isOverridden ? 'overridden-value' : 'current-value'">{{ keyValuePair.value }}</div>
                @if (keyValuePair.isOverridden) {
                    <span class="override-arrow"></span>
                    <div class="current-value">{{ keyValuePair.newValue }}</div>
                }
            </div>
        }
    </div>
    <div class="col col-2">
        @if (savedEstimate?.skipPriceReason) {
            <div class="heading">Siste omsetningsverdi er ikke hensyntatt pga:</div>
            <div class="body">{{ savedEstimate?.skipPriceReason }}</div>
        }
    </div>
    <div class="col col-3">
        @if (savedEstimate?.comment) {
            <h3>Kommentar</h3>
            <div class="body">
                {{ savedEstimate?.comment }}
            </div>
        }
        @if ((savedEstimate.ownership === Ownership.Aksjeleilighet || savedEstimate.ownership === Ownership.Borettslag) && savedEstimate?.shareNumber) {
            <div>
                @if (savedEstimate.ownership === Ownership.Aksjeleilighet) {
                    Aksjebrevsnummer:
                } @else {
                    Andelsnummer:
                }
                {{ savedEstimate?.shareNumber }}
            </div>
        }
        @if (savedEstimate?.signature) {
            <h3>Signatur</h3>
            <div class="body">
                {{ savedEstimate?.signature }}
            </div>
        }
    </div>
</section>
